<template lang="pug"></template>

<script>
export default {
    name: 'BotaoDiagnosticoSocioAmbiental',
    componentOptions: {
        title: 'DiagnosticoSocioAmbiental',
        actions: [
            [
                {
                    name: 'Diagnóstico Socioambiental',
                    iconClass: 'lyra-icon lyra-diagnostico-socio',
                    showView: false,
                    action: 'abrirDiagnosticoSocioambiental',
                    route: 'DiagnosticoSocioambiental'
                }
            ]
        ]
    },

    methods: {
        abrirDiagnosticoSocioambiental() {
            if (this.$route.name !== 'DiagnosticoSocioambiental') {
                this.$router.push({ name: 'DiagnosticoSocioambiental' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
